/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Day_KickerInputs */

const en_features_day_kicker = /** @type {(inputs: Features_Day_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good morning`)
};

const pl_features_day_kicker = /** @type {(inputs: Features_Day_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień dobry`)
};

/**
* | output |
* | --- |
* | "Good morning" |
*
* @param {Features_Day_KickerInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_day_kicker = /** @type {((inputs?: Features_Day_KickerInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Day_KickerInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_day_kicker(inputs)
	return en_features_day_kicker(inputs)
});